import $ from 'jquery';

const TEMP_NODE = $('#temp-cell-dom');
const HTML_COLORS = {
  'aliceblue': '#fff0f8ff',
  'antiquewhite': '#fffaebd7',
  'aqua': '#ff00ffff',
  'aquamarine': '#ff7fffd4',
  'azure': '#fff0ffff',
  'beige': '#fff5f5dc',
  'bisque': '#ffffe4c4',
  'black': '#ff000000',
  'blanchedalmond': '#ffffebcd',
  'blue': '#ff0000ff',
  'blueviolet': '#ff8a2be2',
  'brown': '#ffa52a2a',
  'burlywood': '#ffdeb887',
  'cadetblue': '#ff5f9ea0',
  'chartreuse': '#ff7fff00',
  'chocolate': '#ffd2691e',
  'coral': '#ffff7f50',
  'cornflowerblue': '#ff6495ed',
  'cornsilk': '#fffff8dc',
  'crimson': '#ffdc143c',
  'cyan': '#ff00ffff',
  'darkblue': '#ff00008b',
  'darkcyan': '#ff008b8b',
  'darkgoldenrod': '#ffb8860b',
  'darkgray': '#ffa9a9a9',
  'darkgrey': '#ffa9a9a9',
  'darkgreen': '#ff006400',
  'darkkhaki': '#ffbdb76b',
  'darkmagenta': '#ff8b008b',
  'darkolivegreen': '#ff556b2f',
  'darkorange': '#ffff8c00',
  'darkorchid': '#ff9932cc',
  'darkred': '#ff8b0000',
  'darksalmon': '#ffe9967a',
  'darkseagreen': '#ff8fbc8f',
  'darkslateblue': '#ff483d8b',
  'darkslategray': '#ff2f4f4f',
  'darkslategrey': '#ff2f4f4f',
  'darkturquoise': '#ff00ced1',
  'darkviolet': '#ff9400d3',
  'deeppink': '#ffff1493',
  'deepskyblue': '#ff00bfff',
  'dimgray': '#ff696969',
  'dimgrey': '#ff696969',
  'dodgerblue': '#ff1e90ff',
  'firebrick': '#ffb22222',
  'floralwhite': '#fffffaf0',
  'forestgreen': '#ff228b22',
  'fuchsia': '#ffff00ff',
  'gainsboro': '#ffdcdcdc',
  'ghostwhite': '#fff8f8ff',
  'gold': '#ffffd700',
  'goldenrod': '#ffdaa520',
  'gray': '#ff808080',
  'grey': '#ff808080',
  'green': '#ff008000',
  'greenyellow': '#ffadff2f',
  'honeydew': '#fff0fff0',
  'hotpink': '#ffff69b4',
  'indianred': '#ffcd5c5c',
  'indigo': '#ff4b0082',
  'ivory': '#fffffff0',
  'khaki': '#fff0e68c',
  'lavender': '#ffe6e6fa',
  'lavenderblush': '#fffff0f5',
  'lawngreen': '#ff7cfc00',
  'lemonchiffon': '#fffffacd',
  'lightblue': '#ffadd8e6',
  'lightcoral': '#fff08080',
  'lightcyan': '#ffe0ffff',
  'lightgoldenrodyellow': '#fffafad2',
  'lightgray': '#ffd3d3d3',
  'lightgrey': '#ffd3d3d3',
  'lightgreen': '#ff90ee90',
  'lightpink': '#ffffb6c1',
  'lightsalmon': '#ffffa07a',
  'lightseagreen': '#ff20b2aa',
  'lightskyblue': '#ff87cefa',
  'lightslategray': '#ff778899',
  'lightslategrey': '#ff778899',
  'lightsteelblue': '#ffb0c4de',
  'lightyellow': '#ffffffe0',
  'lime': '#ff00ff00',
  'limegreen': '#ff32cd32',
  'linen': '#fffaf0e6',
  'magenta': '#ffff00ff',
  'maroon': '#ff800000',
  'mediumaquamarine': '#ff66cdaa',
  'mediumblue': '#ff0000cd',
  'mediumorchid': '#ffba55d3',
  'mediumpurple': '#ff9370d8',
  'mediumseagreen': '#ff3cb371',
  'mediumslateblue': '#ff7b68ee',
  'mediumspringgreen': '#ff00fa9a',
  'mediumturquoise': '#ff48d1cc',
  'mediumvioletred': '#ffc71585',
  'midnightblue': '#ff191970',
  'mintcream': '#fff5fffa',
  'mistyrose': '#ffffe4e1',
  'moccasin': '#ffffe4b5',
  'navajowhite': '#ffffdead',
  'navy': '#ff000080',
  'oldlace': '#fffdf5e6',
  'olive': '#ff808000',
  'olivedrab': '#ff6b8e23',
  'orange': '#ffffa500',
  'orangered': '#ffff4500',
  'orchid': '#ffda70d6',
  'palegoldenrod': '#ffeee8aa',
  'palegreen': '#ff98fb98',
  'paleturquoise': '#ffafeeee',
  'palevioletred': '#ffd87093',
  'papayawhip': '#ffffefd5',
  'peachpuff': '#ffffdab9',
  'peru': '#ffcd853f',
  'pink': '#ffffc0cb',
  'plum': '#ffdda0dd',
  'powderblue': '#ffb0e0e6',
  'purple': '#ff800080',
  'red': '#ffff0000',
  'rosybrown': '#ffbc8f8f',
  'royalblue': '#ff4169e1',
  'saddlebrown': '#ff8b4513',
  'salmon': '#fffa8072',
  'sandybrown': '#fff4a460',
  'seagreen': '#ff2e8b57',
  'seashell': '#fffff5ee',
  'sienna': '#ffa0522d',
  'silver': '#ffc0c0c0',
  'skyblue': '#ff87ceeb',
  'slateblue': '#ff6a5acd',
  'slategray': '#ff708090',
  'slategrey': '#ff708090',
  'snow': '#fffffafa',
  'springgreen': '#ff00ff7f',
  'steelblue': '#ff4682b4',
  'tan': '#ffd2b48c',
  'teal': '#ff008080',
  'thistle': '#ffd8bfd8',
  'tomato': '#ffff6347',
  'turquoise': '#ff40e0d0',
  'violet': '#ffee82ee',
  'wheat': '#fff5deb3',
  'white': '#ffffffff',
  'whitesmoke': '#fff5f5f5',
  'yellow': '#ffffff00',
  'yellowgreen': '#ff9acd32'
};
const REGEXPS = {
  GET_ALIGNMENT: /text-align: *([^";]+)/i,
  GET_BACKGROUND_COLOR: /background-color: *([^";]+)/i,
  GET_FONT_COLOR: /[^\w-]color: *([^";]+)/i,
  GET_IMG_SRC: /<img [^>]*src="([^"]+)"/i,
  IS_IT_HTML: /[&<][^\s]/,
  WHITESPACE: /\s+/g
};

function add_options_menu(vm, ref, props) {
  var options = [
    // TODO {text: 'Grid Keys Reference', attr: {id: 'grid-keys-reference'}},
    {text: 'Export to Excel', attr: {id: 'export-to-excel'}},
    {text: 'Export to PDF', attr: {id: 'export-to-pdf'}}
  ];
  if (props.extended_options && props.extended_options.length)
    options = props.extended_options.concat([{divider: true}], options);
  $('<div class="chi-grid-ext-opts k-icon k-i-more-vertical"></div>')
    .appendTo(ref.children('.k-grid-header'))
    .on('click', function () {
      vm.$root.$options.api.events['set-menu']({
        ref: $(this), items: options, grid_id: ref.attr('id'),
        timeout: Math.max(options.length, 5) * 1000
      }, true);
    });
  ref.data('kendo-grid').bind('excelExport', html_to_excel);
}

var compare_text = (new Array(128)).fill(0).map(function (_, i) {
  var key = 'column' + i;
  return function (a, b) {
    a = get_content(a, key);
    b = get_content(b, key);
    return a._content === b._content ? 0 : a._content < b._content ? -1 : 1;
  };
});

var compare_date = (new Array(128)).fill(0).map(function (_, i) {
  var key = 'column' + i;
  return function (a, b) {
    a = get_content(a, key);
    b = get_content(b, key);
    a = a._content ? (new Date(a._content)).getTime() : Date.now();
    b = b._content ? (new Date(b._content)).getTime() : Date.now();
    return a - b;
  };
});

var compare_icon = (new Array(128)).fill(0).map(function (_, i) {
  var key = 'column' + i;
  return function (a, b) {
    a = get_content(a, key, true);
    b = get_content(b, key, true);
    return a._content === b._content ? 0 : a._content < b._content ? -1 : 1;
  };
});

var compare_numeric = (new Array(128)).fill(0).map(function (_, i) {
  var key = 'column' + i;
  return function (a, b) {
    a = get_content(a, key);
    b = get_content(b, key);
    return (+a._content || 0) - (+b._content || 0);
  };
});

var compare_time = (new Array(128)).fill(0).map(function (_, i) {
  var key = 'column' + i;
  return function (a, b) {
    a = get_content(a, key);
    b = get_content(b, key);
    a = (new Date('1/1/1971 ' + (a._content || '23:59:59'))).getTime();
    b = (new Date('1/1/1971 ' + (b._content || '23:59:59'))).getTime();
    return a - b;
  };
});

function get_content(item, key, is_icon) {
  item = item[key] || {_content: ''};
  if (!item._content) {
    item._content = (item.content || '').trim().toLowerCase();
    if (item._content.includes('<')) {
      TEMP_NODE.html(item._content);
      item._content = is_icon ?
        (TEMP_NODE.find('img[data-sort-key]').data('sort-key') || '') :
        TEMP_NODE.get(0).textContent.trim();
      TEMP_NODE.empty();
    }
  }
  return item;
}

function html_to_excel(event) {
  console.debug('export-excel', this, event);
  var now = Date.now();
  if (now - html_to_excel.last < 1000)
    return;
  html_to_excel.last = now;
  event.workbook.fileName =
    this.wrapper.attr('id') + '.' + (now % 1000000) + '.xlsx';
  var sheets = event.workbook.sheets;
  for (var i = sheets.length - 1; i >= 0; --i) {
    var sheet = sheets[i];
    for (var col = sheet.columns.length - 1; col >= 0; --col) {
      sheet.columns[col].autoWidth = true;
      sheet.columns[col].width = undefined;
      for (var style, row = sheet.rows.length - 1; row >= 0; --row) {
        var current_row = sheet.rows[row];
        var cell = current_row.cells[col];
        if (current_row.type === 'data')
          cell = {value: cell.value ? cell.value.content : ''};
        if (REGEXPS.IS_IT_HTML.test(cell.value)) {
          if (style = cell.value.match(REGEXPS.GET_ALIGNMENT))
            cell.textAlign = style[1].trim().toLowerCase();
          if (style = cell.value.match(REGEXPS.GET_BACKGROUND_COLOR))
            cell.background = style[1].trim().toLowerCase();
          if (style = cell.value.match(REGEXPS.GET_FONT_COLOR))
            cell.color = style[1].trim().toLowerCase();
          cell.bold =
            cell.value.includes('<strong>') ||
            cell.value.includes('font-weight: bold');
          cell.italic =
            cell.value.includes('<em>') ||
            cell.value.includes('font-style: italic');
          cell.underline =
            cell.value.includes('text-decoration: underline');
          var $cell = $('<div>' + cell.value + '</div>');
          cell.value = $cell.text().trim().replace(REGEXPS.WHITESPACE, ' ');
        }
        if (cell.color) {
          if (cell.color.startsWith('#')) {
            if (cell.color.length === 4)
              cell.color =
                '#ff' + cell.color[1] + cell.color[1] + cell.color[2] +
                cell.color[2] + cell.color[3] + cell.color[3];
            else
              cell.color = '#ff' + cell.color.substring(1);
          } else if (cell.color in HTML_COLORS) {
            cell.color = HTML_COLORS[cell.color];
          }
        }
        if (cell.background) {
          if (cell.background.startsWith('#')) {
            if (cell.background.length === 4)
              cell.background =
                '#ff' + cell.background[1] + cell.background[1] +
                cell.background[2] + cell.background[2] +
                cell.background[3] + cell.background[3];
            else
              cell.background = '#ff' + cell.background.substring(1);
          } else if (cell.background in HTML_COLORS) {
            cell.background = HTML_COLORS[cell.background];
          }
        }
        current_row.cells[col] = cell;
      }
    }
  }
}

const EMPTY = {content: '&nbsp', hint: ''};
var td_templates = (new Array(128)).fill(0).map(function (_, i) {
  var key = 'column' + i;
  return function (data) {
    data = data[key] || EMPTY;
    return (
      '<div class="chi-td-template-wrapper" title="' + data.hint + '">' +
      data.content + '</div>'
    );
  };
});


export default {
  add_options_menu: add_options_menu,
  td_templates: td_templates,
  tr_compare: compare_text,
  tr_compare_date: compare_date,
  tr_compare_icon: compare_icon,
  tr_compare_numeric: compare_numeric,
  tr_compare_time: compare_time,
};
